<template>
  <div class="imageset-panorama">
    <div class="imageset-panorama__carousel">
      <div class="imageset-panorama__carousel-image-wrapper">
        <vue-easy-lightbox :visible="lightboxVisibility"
                           :imgs="panoramaImage"
                           @hide="closeLightbox">
          <template v-slot:toolbar="{ toolbarMethods }">
            <div class="lightbox-button-wrapper">
              <el-button icon="el-icon-zoom-in" @click="toolbarMethods.zoomIn" />
              <el-button icon="el-icon-zoom-out" @click="toolbarMethods.zoomOut" />
              <el-button icon="el-icon-full-screen" @click="toolbarMethods.resize" />
              <el-button icon="el-icon-refresh-left" @click="toolbarMethods.rotateLeft" />
              <el-button icon="el-icon-refresh-right" @click="toolbarMethods.rotateRight" />
              <el-button icon="el-icon-download" @click="imageDownloader(downloadedImage)" />
            </div>
          </template>
        </vue-easy-lightbox>

        <img :src="panoramaImage"
             class="imageset-panorama__carousel-image"
             @click="openLightbox"
             @error="onImgError">
        <div class="imageset-panorama__carousel-layout">
          {{ $t("Click to zoom") }}
        </div>
      </div>
    </div>
    <div class="imageset-panorama__header">
      <div class="imageset-panorama__store-name">
        {{ store.store_name }}
      </div>
      <div class="imageset-panorama__date">
        {{ maskableTime(store.uploaded_at) }}
      </div>
    </div>
    <div class="imageset-panorama__footer">
      <div class="imageset-panorama__info-left">
        <div class="imageset-panorama__info-grow">
          <div>
            <span class="imageset-panorama__info-title">
              {{ imageset.activity_category_name }}
            </span>
            <span class="imageset-panorama__info-subtitle">
              {{ imageset.image_set_type_name }}
            </span>
          </div>
        </div>
      </div>
      <div class="imageset-panorama__info-right">
        <el-button
          v-if="isReportInspectorActive"
          class="imageset-panorama__info-button"
          @click="$emit('reqReportInspector')">
          <img
            src="/statics/modern-imageset-icons/report-inspector.svg"
            alt="report-inspector">
        </el-button>
        <a class="imageset-panorama__download"
           :href="imageset.mosaic.large"
           download>
          <i class="mdi mdi-download" />
          <span>{{ `${$t("Panorama")} ${$t("Image")}` }}
          </span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import imageDownloader from '@/helpers/imageDownloader';

export default {
  name: 'ImagesetPanorama',
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    store: {
      type: Object,
      default: () => ({})
    },
    isReportInspectorActive: {
      type: Boolean,
      default: false
    },
    imageset: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      lightboxVisibility: false
    };
  },
  computed: {
    panoramaImage() {
      return this.imageset.mosaic.original || this.imageset.mosaic.large;
    }
  },
  methods: {
    openLightbox() {
      this.lightboxVisibility = true;
      this.downloadedImage = this.panoramaImage;
    },
    closeLightbox() {
      this.lightboxVisibility = false;
    },
    imageDownloader
  }
};
</script>

<style lang="scss">
.imageset-panorama {
  &__header {
    display: flex;
    justify-content: space-between;
    padding: 0;
    margin: 0 30px 15px 30px;
    border-bottom: 1px solid #ccc;
  }

  &__store-name {
    margin-bottom: 5px;
    font-size: 15px;
    font-weight: 700;
    color: $blackLacquer;
  }

  &__date {
    font-size: 15px;
  }

  &__carousel {
    display: flex;
    align-items: center;
    margin-bottom: 30px;
  }

  &__carousel-image-wrapper {
    position: relative;
    display: flex;
    flex-grow: 1;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    &:hover {
      .imageset-panorama__carousel-layout {
        visibility: visible;
      }
    }
  }

  &__carousel-image {
    width: auto;
    max-width: 100%;
    max-height: 70vh;
  }

  &__carousel-layout {
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    font-weight: 600;
    color: #bbb;
    pointer-events: none;
    visibility: hidden;
    background: rgba(0, 0, 0, 0.5);
  }

  &__footer {
    display: flex;
    padding: 0 30px;
  }

  &__info-left {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }

  &__info-right {
    display: flex;
    flex-grow: 1;
    justify-content: flex-end;
  }

  &__info-button {
    padding: 0 20px;
    background: none !important;
    border: none;
    border-radius: 0;
    outline: 0;

    img {
      width: 27px !important;
      height: auto;
    }
  }

  &__info-grow {
    flex-grow: 1;
  }

  &__info-title {
    display: inline-block;
    padding: 5px 10px;
    font-size: 15px;
    font-weight: 600;
    color: #fff;
    background: $greyShingle;
    border-radius: 50px;
  }

  &__info-subtitle {
    display: inline-block;
    padding: 5px 10px;
    font-size: 15px;
    font-weight: 600;
    color: $greyShingle;
  }

  &__download {
    display: flex;
    align-items: center;
    padding: 0 20px;
    font-size: 12px;
    color: $tooGold;
    cursor: pointer;
    background: none;
    border: none;
    border-left: 1px solid $hydrargyrum;
    outline: none;

    i {
      padding-right: 5px;
      font-size: 30px;
    }
  }

  @media (max-width: 640px) {
    &__header {
      padding: 0 15px;
      margin: 0 0 15px 0;
    }

    &__footer {
      align-items: center;
      padding: 0 15px;
    }

    &__info-button {
      padding: 0 10px;
      background: none !important;
      border: none;
      border-radius: 0;
      outline: 0;

      img {
        width: 20px !important;
        height: auto;
      }
    }
  }
}

</style>
